import { createFileRoute } from "@tanstack/react-router";
import { StudioPage } from "lib/components/studio/StudioPage";
import withAuthentication from "../components/withAuthentication";

// Hoist the wrapped component to a module-level constant so this file
// produces a STABLE component reference across HMR. Calling
// withAuthentication(...) inline inside createFileRoute would generate a
// new function reference every time this module re-evaluates (e.g. when
// downstream SCSS HMR cascades up through React fast-refresh) — and
// TanStack Router treats a new component reference as a different route,
// remounting StudioPage beside the existing one. The visible symptom was
// a doubled Studio shell during active SCSS edits.
const StudioRoute = withAuthentication(StudioPage, { permissions: ["VIEW_STUDIO_FILES"], products: ["studio"] });

export const Route = createFileRoute("/studio")({
  component: StudioRoute,
});
